import { createSelector } from '@ngrx/store';

import { InformativeMessage } from '@models/swagger';
import { State } from './reducer';
import { selectInformativeMessagesState } from '../selectors';

export const getData = createSelector(selectInformativeMessagesState, (state: State) => state.data);

export const getError = createSelector(selectInformativeMessagesState, (state: State) => state.error);

export const getLoading = createSelector(selectInformativeMessagesState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: InformativeMessage[]) => T) =>
  createSelector(selectInformativeMessagesState, (state: State) => fn(state.data));
